import React from 'react'

interface ITagProps extends React.HTMLProps<HTMLSpanElement> {
  variant?: 'default' | 'primary' | 'warning' | 'error' | 'success'
  skeleton?: boolean
}

const Tag: React.FC<ITagProps> = ({
  children,
  variant = 'default',
  skeleton,
  ...rest
}) => (
  <span
    className={`tag tag-${variant} ${skeleton ? 'skeleton' : ''}`}
    {...rest}
  >
    {children}
  </span>
)

export default Tag
